import React from 'react'

function FormLabel(props: { required?: boolean, className?: string, children?: React.ReactNode, htmlFor?:string }) {
    const {required = false, children, className = '', htmlFor = '' } = props

    return (
        <label htmlFor={htmlFor} className={`block text-sm font-medium text-gray-700 ${className}`}>
            {children}
            {required && (
                <sup className="pt-1 text-sm leading-3 text-red-500">*</sup>
            )}

        </label>
    )
}

export default FormLabel;2
